import React from 'react';
import DocumentTitle from 'react-document-title';
import { Link } from 'react-router-dom';
import Media from 'react-media'
import Slider from 'react-slick';

import './Splash.scss';


const Desktop = () => (
  <div className="row no-gutters align-self-stretch desktop">
    <div className="col wall">
      <div>
        <Link className="link" to={{
          pathname:"/browse",
          state: { productType: 'wall' }
        }}>Brandmūri</Link>
      </div>
    </div>
    <div className="col transport">
    <div>
        <Link className="link" to="/gallery">Sabiedriskais transports</Link>
      </div>
    </div>
  </div>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};

const Mobile = () => (
    <div className="mobile">
      <Slider {...settings}>
        <div className="wall">
          <div>
            <Link className="link" to={{
              pathname:"/browse",
              state: { productType: 'wall' }
            }}>Brandmūri</Link>
          </div>
        </div>  
        <div className="transport">
          <div>
            <Link className="link" to="/gallery">Sabiedriskais transports</Link>
          </div>
        </div>
      </Slider>
    </div>
);

const Splash = () => (
  <div id="splash">
    <DocumentTitle title="Sākums - e-BML" />
    <Media query={{ maxWidth: 575 }}>
      {matches => matches ? <Mobile /> : <Desktop />}
    </Media>      
  </div>
);

export default Splash;


// WEBPACK FOOTER //
// ./src/components/Splash/index.js